import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
let modalsShowing = 0; // I don't like these magic numbers but I haven't found a better way

const MODAL_VISIBILITY_CHANGE_DELAY = 16;
const MODAL_TRANSITION_DELAY = 150;

function modalWillShow() {
  var _document;

  if (modalsShowing === 0 && typeof document !== 'undefined' && (_document = document) !== null && _document !== void 0 && _document.body) {
    document.body.classList.add('modal-open');
  }

  modalsShowing += 1;
}

function modalWillHide() {
  var _document2;

  modalsShowing -= 1;

  if (modalsShowing === 0 && typeof document !== 'undefined' && (_document2 = document) !== null && _document2 !== void 0 && _document2.body) {
    document.body.classList.remove('modal-open');
  }
}

function Modal(props) {
  var _props$visible, _props$fade3;

  const [visible, setVisible] = useState((_props$visible = props.visible) !== null && _props$visible !== void 0 ? _props$visible : false);
  const [modalIndex, setModalIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const wasVisibleRef = useRef(false);
  useEffect(() => {
    if (props.visible) {
      modalWillShow();
      wasVisibleRef.current = true;
    } else if (wasVisibleRef.current) {
      modalWillHide();
    }

    if (props.visible || wasVisibleRef.current) {
      var _props$fade;

      if ((_props$fade = props.fade) !== null && _props$fade !== void 0 ? _props$fade : true) {
        setTransitioning(true);
        setModalIndex(modalsShowing);

        if (typeof window !== 'undefined') {
          const visibilityChangeTimeout = window.setTimeout(() => setVisible(props.visible), MODAL_VISIBILITY_CHANGE_DELAY);
          const transitionEndTimeout = window.setTimeout(() => setTransitioning(false), MODAL_TRANSITION_DELAY);
          return () => {
            window.clearTimeout(transitionEndTimeout);
            window.clearTimeout(visibilityChangeTimeout);
          };
        }
      } else {
        setVisible(props.visible);
      }
    }
  }, [props.visible]);

  const renderBackdrop = () => {
    if (visible || transitioning) {
      var _props$fade2;

      return /*#__PURE__*/_jsx("div", {
        className: classNames('modal-backdrop', {
          show: visible,
          fade: (_props$fade2 = props.fade) !== null && _props$fade2 !== void 0 ? _props$fade2 : true
        }),
        onClick: props.onClickBackdrop,
        role: "presentation",
        style: {
          zIndex: 1040 + modalIndex
        }
      });
    }

    return null;
  };

  const {
    wrapperProps,
    visible: unusedVisible,
    className,
    dialogClassName,
    onClickBackdrop,
    children,
    fade,
    ...other
  } = props;
  return /*#__PURE__*/_jsxs("div", { ...wrapperProps,
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames('modal', {
        show: visible,
        fade: (_props$fade3 = props.fade) !== null && _props$fade3 !== void 0 ? _props$fade3 : true
      }, className),
      style: {
        display: visible || transitioning ? 'block' : 'none',
        zIndex: 1040 + modalIndex + 1
      },
      role: "dialog",
      "aria-hidden": !visible,
      tabIndex: -1,
      onClick: onClickBackdrop,
      ...other,
      children: /*#__PURE__*/_jsx("div", {
        className: classNames('modal-dialog', dialogClassName),
        role: "document",
        onClick: event => event.stopPropagation(),
        children: /*#__PURE__*/_jsx("div", {
          className: "modal-content",
          children: children
        })
      })
    }), renderBackdrop()]
  });
}

export default Modal;
//# sourceMappingURL=Modal.js.map